<template>
    <FKBreadCrumb :page="$t('page.contents')" :title="$t('page.content_library')">
        <FKBreadCrumbItem :page="$t('page.content_categories')" to="/contents" />
    </FKBreadCrumb>
    <ContentCategoryList />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ContentCategoryList from "@/components/FK/Contents/Categories/ContentCategoryList.vue";
import FKBreadCrumb from '@/components/Widgets/BreadCrumb/FKBreadCrumb.vue';
import FKBreadCrumbItem from '@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue';

export default defineComponent({
    name: 'ContentCategoryPage',
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ContentCategoryList
    },
})
</script>